export default __webpack_public_path__ + "static/media/background.752ed31c.jpeg";